import ClickAndCollectSelectedPoint from './ClickAndCollectSelectedPoint';

export default ClickAndCollectSelectedPoint;
